import { TourConfig } from "@/types/tour"
import { standardOffset } from "./utils/floatingUIConfigs"

/**
 * Tour configuration for the Combination Explorer page
 */
export const combinationExplorerTour: TourConfig = {
   id: "combination_explorer_tour",
   humanReadableName: "Combination Explorer Tour",
   skippable: true,
   options: {
      useModalOverlay: true,
      defaultStepOptions: {
         classes: "q-card q-dark-transition shepherd-theme-quasar",
         arrow: true,
         scrollTo: { behavior: "smooth", block: "center" },
      },
   },
   steps: [
      {
         id: "welcome",
         title: "Welcome to the Combination Explorer",
         text: "This tour will guide you through the Combination Explorer page and explain its key features.",
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
      },
      {
         id: "traffic-distribution-graph",
         text: `This graph helps you see which versions of your website are shown most often by displaying how ezbot is distributing traffic across different combinations over time. Each colored area represents one of the top five most-served combinations. The grey area represents the traffic all other combinations shown. The height of each color shows the share (%) of total traffic that combination received at any point in time.`,
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         attachTo: {
            element: "#traffic-graph",
            on: "bottom",
         },
         floatingUIOptions: standardOffset,
      },
      {
         id: "conversion-rate-graph",
         text: `Use this graph to track the performance of the same top combinations over time. Each line represents one of the combination above, tracking its conversion rate throughout the selected time period.`,
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         attachTo: {
            element: "#conversion-graph",
            on: "bottom",
         },
         floatingUIOptions: standardOffset,
      },
      {
         id: "combinations-table",
         text: `Use this table to stop dive deeper into your data. It displays a detailed breakdown of every single combination ezbot is testing. You can sort by metrics like traffic share (%), sessions served, total conversions, conversion rates, and see other key metrics about your combinations.`,
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         attachTo: {
            element: "#combinations-table",
            on: "top",
         },
         floatingUIOptions: standardOffset,
      },
      {
         id: "tour-complete",
         text: "You've completed the Combination Explorer tour! You can now explore this page to gain deeper insights into how your site variations are performing.",
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  if (this.complete) return this.complete()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Complete",
            },
         ],
         floatingUIOptions: standardOffset,
      },
   ],
}
